import Vue from 'vue' // 引入vue
import VueRouter from 'vue-router'
import Main from "@/views/Main.vue";
import Home from "@/views/home/index.vue";
import Staff from "@/views/home/staff/index.vue";
import Production from "@/views/home/production/index.vue";
import Salary from "@/views/home/salary/index.vue";
import Mine from "@/views/mine/index.vue";
import Settings from "@/views/mine/settings/index.vue";
import Profile from "@/views/mine/profile/index.vue";
import Login from "@/views/login/index.vue";
import Add from "@/views/form/staff/index.vue";
import Finish from "@/views/form/finish/index.vue";
import Total from "@/views/performance/total/index.vue";
import Detail from "@/views/performance/detail/index.vue";
import Costs from "@/views/form/costs/index.vue";
import Complete from "@/views/form/complete/index.vue";

Vue.use(VueRouter) // 全局引入路由

const routes = [
    {
        path: '/',
        component: Main,
        redirect: "/login",
        children: [
            {
                path: "/login",
                component: Login,
            },
            {
                path: "/home",
                component: Home,
            },
            {
                path: "/mine",
                component: Mine,
            },
        ]
    },
    { path: '/staffTotal', component: Staff },
    { path: '/productionTotal', component: Production },
    { path: '/salaryTotal', component: Salary },
    { path: '/settings', component: Settings },
    { path: '/profile', component: Profile },
    { path: '/login', component: Login },
    { path: '/staff/add', component: Add },
    { path: '/form/finish', component: Finish },
    { path: '/performance/total', component: Total },
    { path: '/performance/detail', component: Detail },
    { path: '/costs/add', component: Costs },
    { path: '/costs/complete', component: Complete },
]

// router实例
const router = new VueRouter({
    mode: 'history', // 此模式下，url不出现"#"
    routes, // 记住前面的属性是routes(路线)，而不是routers(路由器)，不然<router-view>的内容不会显示
})

// 重置路由
export const resetRouter = () => {
    router.matcher = new VueRouter({
        mode: 'history', routes
    })
}

export default router // 对外暴露